import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '../webApi'
import { Reference } from '../webApi/DataModels'
import { map } from 'lodash'
import constants from '../constants'

class ReferenceState {
  public references: Reference[] = []
}
const mutations = <MutationTree<ReferenceState>>{
  setReferences (state: ReferenceState, references: Reference[]): void {
    state.references = references
  },
  reset (state:ReferenceState) {
    state.references = null
  }
}
const actions = <ActionTree<ReferenceState, any>>{
  loadReferences (store: ActionContext<ReferenceState, any>): Promise<any> {
    return webApi.reference.get_Reference_Type_List()
      .then((response) => {
        store.commit('setReferences', response.data)
        return Promise.resolve()
      }).catch((error) => {
        return Promise.reject(error)
      })
  },
  reset (store: ActionContext<ReferenceState, any>): void {
    store.commit('reset')
  }
}
const getters = <GetterTree<ReferenceState, any>>{
  emptyReferenceValues (state: ReferenceState): any[] {
    var referenceValues:any[] = []
    map(state.references, (reference) => {
      referenceValues.push({
        Reference_Type_ID: reference.Reference_Type_ID,
        Reference_Type_Name: reference.Reference_Type_Name,
        Reference_Text: ''
      })
    })
    return referenceValues
  },
  emptyReferenceValuesWithoutCounterNumber (state: ReferenceState): any[] {
    var referenceValues:any[] = []
    map(state.references, (reference) => {
      if (reference.Reference_Type_ID !== constants.REFERENCE_TYPE_ID.COUNTER_NUMBER) {
        referenceValues.push({
          Reference_Type_ID: reference.Reference_Type_ID,
          Reference_Type_Name: reference.Reference_Type_Name,
          Reference_Text: ''
        })
      }
    })
    return referenceValues
  }
}
export default ({
  namespaced: true,
  state: new ReferenceState(),
  mutations,
  actions,
  getters
})
